import { ApiRoutingUtils } from '@/Routing';
import { rest } from '@/Api/Rest';
import { UpdateDeutschePostContractStateRequest } from './Requests/UpdateDeutschePostContractStateRequest';
import { UpdateDeutschePostContractStateResponse } from './Responses/UpdateDeutschePostContractStateResponse';
import { GetDeutschePostContractResponse } from './Responses/GetDeutschePostContractResponse';
import { CreateDeutschePostContractRequest } from './Requests/CreateDeutschePostContractRequest';
import { CreateDeutschePostContractResponse } from './Responses/CreateDeutschePostContractResponse';
import { UpdateDeutschePostContractRequest } from './Requests/UpdateDeutschePostContractRequest';
import { UpdateDeutschePostContractResponse } from './Responses/UpdateDeutschePostContractResponse';
import { GetDeutschePostContractStatusRequest } from './Requests/GetDeutschePostContractStatusRequest';
import { GetDeutschePostContractStatusResponse } from './Responses/GetDeutschePostContractStatusResponse';
import { GetDeutschePostFormatsResponse } from './Responses/GetDeutschePostFormatsResponse';

const url = ApiRoutingUtils.createUrl('deutsche-post-internetmarke-contracts');

async function getContract(id: number): Promise<GetDeutschePostContractResponse> {
  return rest.get(`${url}/${id}`);
}

async function createContract(request: CreateDeutschePostContractRequest): Promise<CreateDeutschePostContractResponse> {
  return rest.post(url, request);
}

async function updateContract(request: UpdateDeutschePostContractRequest): Promise<UpdateDeutschePostContractResponse> {
  return rest.put(url, request);
}

async function deleteContract(id: number): Promise<number> {
  return rest.delete(`${url}/${id}`, null);
}

async function checkConnection(
  request: GetDeutschePostContractStatusRequest,
): Promise<GetDeutschePostContractStatusResponse> {
  return rest.post(`${url}/check-connection`, request);
}

async function getLabelFormats(): Promise<GetDeutschePostFormatsResponse> {
  return rest.get(`${url}/marke-formats`);
}

async function updateContractState(
  request: UpdateDeutschePostContractStateRequest,
): Promise<UpdateDeutschePostContractStateResponse> {
  return rest.put(`${url}/update-state`, request);
}

export const LogisticDeutschePostApi = {
  getContract,
  createContract,
  updateContract,
  deleteContract,
  checkConnection,
  getLabelFormats,
  updateContractState,
};
